import { reatomAsync, withAbort } from "@reatom/async";
import { ExportTaskIdDto } from "definitions/exporter";
import { API } from "src/api";
import { toastHandler, truncateStart } from "src/util";

export const cancelExportJobRequest = reatomAsync(
  async (ctx, data: ExportTaskIdDto) => {
    API.exporterQueueApi
      .exportControllerAbortJobById(data, {
        signal: ctx.controller.signal,
      })
      .then((response) => {
        const success = response.data;
        if (success) {
          toastHandler.success({
            name: "stopExportJob",
            title: "Отмена задачи",
            content: `Задача ${truncateStart(data.id)} отменена`,
          });
        } else {
          toastHandler.error({
            name: "stopExportJob",
            title: "Отмена задачи",
            content: `Задачу ${truncateStart(data.id)} не удалось отмененить`,
          });
        }
      });
  },
  {
    name: "cancelExportJobRequest",
  },
).pipe(withAbort());
